import { render, staticRenderFns } from "./EditCourseExitParticipants.vue?vue&type=template&id=d575f52a"
import script from "./EditCourseExitParticipants.vue?vue&type=script&lang=js"
export * from "./EditCourseExitParticipants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports